import React, { useEffect, useState } from 'react'
import styles from './viewall.module.scss'
import Layout from 'partials/layout'
import { ERCText } from 'components/text'
import SideFilter from 'components/sidefilterr'
import art from 'assets/images/arts.svg'
import commercial from 'assets/images/commercial.svg'
import sciences from 'assets/images/sciences.svg'
import CourseCardSmall from 'components/studentcoursecardsm'
import RecommendedCourses from 'components/recommendedcoursescard'
import GamesCard from 'components/gamescard'
import TestimonialCard from 'components/testimonialcard'
import { basic_schools, courses, secondary_schools, subjects } from 'assets/dummy/collections'

const StudentsViewAll = () => {

   const [filterValues, setFilterValues] = useState({})
  
   const handleFilterChange = (e) => {
    console.log(e)
    setFilterValues(prev => ({ ...prev, [e?.name]: e?.value}))
   }

   const [filteredCourses, setFilteredCourses] = useState(courses)
   useEffect(() => {

       const keys = Object.keys(filterValues)

       const runFilter = (key, arr, value) => {
           const result = arr?.filter(item => item[key] === value) || []
           if (value) return result
           return arr
       }
       setFilteredCourses(prev => {
           const classFilter = runFilter('class', courses, filterValues?.class)
           const subjectFilter = runFilter('subject', classFilter, filterValues?.subject)
           const categoryFilter = runFilter('category', subjectFilter, filterValues?.category)
           const subCategoryFilter = runFilter('subCategory', categoryFilter, filterValues?.subCategory)
           return subCategoryFilter
       })
       console.log(filterValues)
   }, [filterValues])
    
    return (

        <Layout mqcolor='#00296B' >
            <div className={styles.body}>
                <div className={styles.header} >
                    ll
                </div>
                <div className={styles.coursesbody} >
                    <div className={styles.explore} >
                        <ERCText align='justify' weight='700' size='24px' lHeight='32px' >Explore Courses From Our Teachers</ERCText>
                        <ERCText align='justify' size='14px' weight='400' lHeight='20px' >Immerse yourself in courses crafted by expert educators, subject matter experts, and industry professionals. Our carefully curated curriculum is designed to align with educational standards, incorporate best practices, and deliver high-quality content that fosters academic excellence and personal growth</ERCText>
                    </div>
                    <div className={styles.courses} >
                        <div className={styles.side} >
                            <div className={styles.filter} >
                            <SideFilter title={'Subjects'} name={'subject'} viewAll data={subjects} onChange={handleFilterChange} />
                            <SideFilter key={filterValues?.class + "basic"} title={'Basic Education Level'} defaultValue={filterValues?.class} name={'class'} data={basic_schools} onChange={handleFilterChange} />
                            <SideFilter key={filterValues?.class + "Secondary"} title={'Secondary Education Level'} defaultValue={filterValues?.class} name={'class'} data={secondary_schools} onChange={handleFilterChange} />
                            </div>
                            <div className={styles.recommend} >
                                <ERCText align='justify' size='16px' weight='700' lHeight='24px' >Recommended Courses</ERCText>
                                <div className={styles.cont}>
                                    <RecommendedCourses img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946723/ERC/maths_vljukk.svg"} title={'Introduction To Further Mathematics For SS1'} category={'Sciences'} />
                                    <RecommendedCourses img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946732/ERC/civic_kmiysm.svg"} title={'Introduction To Civic Education For JSS1'} category={'Arts & Humanities'} />
                                    <RecommendedCourses img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718947254/ERC/biz-study_uai6sd.svg"} title={'Introduction To Business Studies For JSS1'} category={'Commercial'} />
                                </div>
                            </div>
                        </div>
                        <div className={styles.viewall} >
                        {filteredCourses.map((course) => <CourseCardSmall duration={course.duration} img={commercial} text={course.subCategory} description={course?.description} title={course?.title} />)}
                        </div>
                    </div>

                    <div className={styles.pag} >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.5">
                                <rect width="40" height="40" rx="5" fill="#F6B40A" />
                                <path d="M23.9502 14.2625L18.2252 20L23.9502 25.7375L22.1877 27.5L14.6877 20L22.1877 12.5L23.9502 14.2625Z" fill="white" />
                            </g>
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.625" y="0.625" width="38.75" height="38.75" rx="4.375" stroke="#FFD600" stroke-width="1.25" />
                            <path d="M16.0498 14.2625L21.7748 20L16.0498 25.7375L17.8123 27.5L25.3123 20L17.8123 12.5L16.0498 14.2625Z" fill="#00296B" />
                        </svg>
                    </div>
                </div>

                <div className={styles.educational} >
                    <ERCText color='#00296B' size='14px' weight='700' lHeight='20px' >EDUCATIONAL GAMES</ERCText>
                    <hr style={{ border: "1.5px solid #FFD600", width: '60px', }} />
                    <div className={styles.eduheader} >
                        <ERCText size='40px' weight='700' lHeight='48px' >Student Fun Center</ERCText>
                        <ERCText size='18px' width='75%' lHeight='20px' weight='400' align='center' >We ignite the spark of curiosity, foster creativity, and empower students to discover the wonders of knowledge in the most delightful of ways</ERCText>
                    </div>
                    <div className={styles.eduslider} >
                        <GamesCard img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946550/ERC/scrabble_shwc9k.svg"} title={'Scrabble Board Game'} />
                        <GamesCard img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718952323/ERC/pexels-monstera-6281878_1_cwv7zy.jpg"} title={'Ise Board Game'} />
                        <GamesCard img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718952323/ERC/pexels-monstera-6281878_2_pzyvqs.jpg"} title={'African Tour Jigsaw'} />
                        <GamesCard img={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946723/ERC/3d_dice_f1agct.svg"} title={'3D Dice Game'} />
                    </div>
                </div>
                <div className={styles.testimonials} >
                    <div className={styles.testimonialsheader} >
                        <div className={styles.textbg} >
                            <ERCText size='40px' weight='700' lHeight='48px' align='center' >Testimonials</ERCText>
                        </div>
                        <ERCText color='#252525' size='18px' weight='400' lHeight='20px' >Student Voices: Testimonials on Our Web App Experience</ERCText>
                    </div>
                    <div className={styles.stories} >
                        <TestimonialCard name={'Damilola Peter'} occupation={'Student'} note={"The web app has been my go-to study buddy. Whether I need extra practice for exams or want to explore new topics, I can always count on the app to provide helpful resources and interactive learning activities. It's like having a virtual classroom right at my fingertips!"} />
                        <TestimonialCard name={'Ayomide Sayo'} occupation={'Student'} note={"Using the web app has been a game-changer for me! It's made learning so much more interactive and engaging. I love how easy it is to access educational resources and play fun games that reinforce what I've learned in class"} />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default StudentsViewAll